<template>
  <div class="animated fadeIn list-of-jurnal">
    <b-card>
      <div slot="header">
        Journal Link from Submodul
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="showUploadFrm=true">
            <i class="fa fa-cloud-upload"></i> Import/Upload
          </b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-dropdown text="Posting" variant="primary mr-1" >
            <b-dropdown-item @click="posting" :disabled="!(model)">Posting 1 JV </b-dropdown-item>
            <b-dropdown-item @click="postingselected" :disabled="(selected.length==0)">Posting Selected {{selected.length}} JV </b-dropdown-item>
            <b-dropdown-item @click="postingall" >Posting All JV </b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="printjv()">
            <i class="fa fa-print"></i> Print JV
          </b-button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i> Filter
          </b-button>
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Description</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.uraian"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Dimension Name</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
            <b-input-group-prepend>
              <span class="input-group-text">value</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuDimShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Trx. Date</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Journal Number</label></b-input-group-prepend>
              <b-form-input v-model="tblData.nomor" placeholder="nomor (% for wildcard)"></b-form-input>
              <b-input-group-prepend><span class="pt-2">Group &nbsp;</span></b-input-group-prepend>
              <b-form-select v-model="tblData.kodejurnal" :plain="true" :options="jurnalGroup"></b-form-select>
            </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>GL Account</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
            <b-form-input
              v-model="tblData.namaacc"
              placeholder="Account Name"
              class="ml-1"
              style="width:30% !important"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Reference</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.reff" placeholder="Reference/Remark"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3 mr-1" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear Filter
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        v-model="items"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
        selectable
        :select-mode="selectMode"
        @row-selected="onRowSelected"

      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print JV</b-dropdown-item>
          <b-dropdown-item @click="rowPosting(data.item)" href="#" style="padding:0 !important;">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-nojurnal="data.item.no_jurnal"
            :data-tanggal="data.item.tanggal"
            :data-kodejurnal="data.item.kodejurnal"
            :data-jurnalkey="data.item.jurnalkey"
            :checked="ischeckedjurnal([data.item.no_jurnal, data.item.tanggal,data.item.kodejurnal])"
          />
        </template>
        <template v-slot:cell(tanggal)="data">{{ data.item.tanggal | moment("DD MMM YYYY") }}</template>
        <template v-slot:cell(kodeacc)="data">
          <span
            v-if="(data.item.judul=='Y')"
            style="color:red;"
          >{{data.item.kodeacc}} | {{data.item.namaacc}}</span>
          <span v-else>{{data.item.kodeacc}} | {{data.item.namaacc}}</span>
        </template>
        <template v-slot:cell(umasuk)="data">{{data.item.umasuk|numFormat}}</template>
        <template v-slot:cell(ukeluar)="data">{{data.item.ukeluar|numFormat}}</template>
        <template v-slot:cell(Dim1)="data">
          <span v-if="(data.item.Dim1)">{{data.item.Dim1}} | {{data.item.Dim1Txt}}</span>
        </template>
        <template v-slot:cell(Dim2)="data">
          <span v-if="(data.item.Dim2)">{{data.item.Dim2}} | {{data.item.Dim2Txt}}</span>
        </template>
        <template v-slot:cell(Dim3)="data">
          <span v-if="(data.item.Dim3)">{{data.item.Dim3}} | {{data.item.Dim3Txt}}</span>
        </template>
        <template v-slot:cell(Dim4)="data">
          <span v-if="(data.item.Dim4)">{{data.item.Dim4}} | {{data.item.Dim4Txt}}</span>
        </template>
        <template v-slot:cell(Dim5)="data">
          <span v-if="(data.item.Dim5)">{{data.item.Dim5}} | {{data.item.Dim5Txt}}</span>
        </template>
        <template v-slot:cell(Dim6)="data">
          <span v-if="(data.item.Dim6)">{{data.item.Dim6}} | {{data.item.Dim6Txt}}</span>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right" vif="pagination" 
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 Journal is about to be deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showUploadFrm" size="lg" title="Import/Upload Journal" @ok="uploadJv">
      <b-input-group>
        <b-input-group-prepend>
          <span class="input-group-text">Choose *.XLSX file</span>
        </b-input-group-prepend>
        <b-form-file
          v-model="fileXlsx"
          :state="Boolean(fileXlsx)"
          placeholder="Choose a XLSX file..."
          drop-placeholder="Drop XLSX file here..."
        ></b-form-file>
      </b-input-group>
      <b-link @click="downloadtemplate">
        <i class="fa fa-paperclip"></i> EkosSystem-JV-upload-template.xlsx
      </b-link>
    </b-modal>
    <b-modal
      v-model="lkuDimShow"
      size="lg"
      :hide-footer="true"
      title="List of Dimension Value"
      :centered="true"
    >
      <lku-dim @click="onSelectedDim" :DimColName="tblData.DimCol" :key="tblData.DimCol"></lku-dim>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-jurnal {
    table {
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
   }
</style>

<script>
// import $ from 'jquery'

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import jurnal from "../../apis/jurnal";
import lkuDim from "../lookup/lkuDim";
toastr.init();
export default {
  data() {
    return {
      lkuDimShow: false,
      showDelConfirm: false,
      horizontal: true,
      showFilter: false,
      isLoading: false,
      showReport: false,
      showUploadFrm: false,
      fileXlsx: null,
      reportUrl: null,
      items: [],
      limit:15,
      pagination:false,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "no_jurnal",
        sortDesc: false,
        DimCol: "Dim1"
      },
      jurnalGroup:[{ value: '', text: '-- All Source -' }, 
              { value: 'AP%', text: '-- AP Related --' },
              { value: 'AR%', text: '-- AR Related --' },
              { value: '%ADV%', text: '-- ADVANCE Related --' },
              { value: '%JV%', text: '-- JV Manual --' },
              { value: 'BANK%', text: '-- Bank --' },
              { value: 'INV%', text: '-- Inventory --' },
      ],
      model:{},
      selected: []
    };
  },
  components: { Loading, lkuDim },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
    page() {
      return this.tblData.page;
    },
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
        {
          key: "selected",
          label: "",
          thStyle: "width:20px",
          thClass:"text-center",
          tdClass:"text-center",
        },
        {
          key: "no_jurnal",
          label: "JV Number",
          sortable: true
        },
        {
          key: "tanggal",
          thStyle: "width:90px",
          label: "JV Date",
          sortable: true
        },
        {
          key: "kodeacc",
          label: "Account",
          sortable: true
        },
        {
          key: "uraian",
          label: "Description"
        },
        {
          key: "umasuk",
          label: "Debit",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "ukeluar",
          label: "Credit",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        }
      ];
      const dims = this.$store.state.dimension;
      for (let i = 0; i < dims.length; i += 1) {
        fields.push({
          key: dims[i].value,
          label: dims[i].text,
          sortable: true
        });
      }

      // fields.push({
      //   key: "action",
      //   label: "Action",
      //   thStyle: "width:40px",
      //   thClass: "text-center"
      // });
      return fields;
    }
  },
  watch: {
    dimCol: function(newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find(
        d => d.value === newval
      ).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
  },
  // sockets: {
  //   jurnaltrx: function(data) {
  //     if (data.compcode === this.$store.state.user.compcode) {
  //       this.refresh();
  //     }
  //   }
  // },
  created: async function(){
      const kodeList = await jurnal.kodejurnal();
      this.jurnalGroup = kodeList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },this.jurnalGroup);

  },    
  methods: {
    ischeckedjurnal(valArr){
      const findjv = this.selected.find(x => ((x.no_jurnal === valArr[0]) && (x.kodejurnal === valArr[2]) && (x.tanggal === moment(valArr[1]).format('YYYY-MM-DD'))));
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedjurnal(item,record) {
      this.rowClicked(record);
      const jurnalkey = item.target.attributes["data-jurnalkey"].value;
      const no_jurnal =  item.target.attributes["data-nojurnal"].value;
      const kodejurnal =  item.target.attributes["data-kodejurnal"].value;
      const tanggal = moment(item.target.attributes["data-tanggal"].value).format('YYYY-MM-DD');
      if (item.target.checked) {
        const findjv = this.selected.find(x => ((x.no_jurnal === no_jurnal) && (x.kodejurnal === kodejurnal) && (x.tanggal === tanggal)));
        if (!(findjv)){
          this.selected.push({
            jurnalkey,
            no_jurnal,
            kodejurnal,
            tanggal
          });
        }
      } else {
        const findIdx = this.selected.findIndex(x => ((x.no_jurnal === no_jurnal) && (x.kodejurnal === kodejurnal) && (x.tanggal === tanggal)));
        this.selected.splice(findIdx, 1);
      }
    },
    onSelectedDim: function(_selected) {
      this.tblData.DimVal = _selected.nama;
      this.tblData.DimValCode = _selected.kode;
      this.tblData.DimValInfo = `${_selected.kode.trim()} | ${_selected.nama}`;
      this.lkuDimShow = false;
    },
    downloadtemplate: function() {
      jurnal.downloadtemplate();
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
      this.pagination=false;
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.jvlist) {
        this.tblData[key] = filter.jvlist[key];
        filtered = true;
      }
      if (filtered === true) {
            this.tblData.tgl1=filter.jvlist.tgl1 || '';
            this.tblData.tgl2=filter.jvlist.tgl2 || '';
        this.showFilter = filtered;
        delete filter.jvlist;
        this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                // this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
                  const list = await jurnal.list(this.tblData);
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                // this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
                  const list = await jurnal.list(this.tblData);
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
      this.tblData.kodeacc = "";
      this.tblData.namaacc = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.kodejurnal = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
      this.tblData.DimValCode = "";
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc',
        "uraian",
        "DimCol",
        "DimVal",
        "DimValCode",
        "tgl1",
        "tgl2",
        "nomor",
        "kodejurnal",
        "kodeacc",
        "namaacc"
      ];
      let filtered = false;
      const jvlist = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          jvlist[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        jvlist.page = this.tblData.page;
        jvlist.limit = this.tblData.limit;
        jvlist.sortBy = this.tblData.sortBy;
        jvlist.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.jvlist = jvlist;
        this.$store.commit("filter", filter);
      }
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowPosting(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },

    edit: function() {
      if (this.model.jurnalkey) {
        this.saveFilter();
        router.push({
          name: "accounting.jurnalfrm",
          params: { nomor: this.model.no_jurnal, tanggal: moment(this.model.tanggal).format('YYYY-MM-DD'), kodejurnal: this.model.kodejurnal }
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model.jurnalkey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function() {
      this.isLoading = true;
      await jurnal.remove({ nomor: this.model.no_jurnal, tanggal: moment(this.model.tanggal).format('YYYY-MM-DD'), kodejurnal: this.model.kodejurnal });
      this.refresh();
      // const objdeleted = this.items.filter(r => ((r.no_jurnal==this.model.no_jurnal) && (r.tanggal==this.model.tanggal)));
      // if (objdeleted) {
      //     objdeleted.forEach((d) => {
      //           const index= this.items.findIndex(r => (r.bukukey==d.bukukey));
      //           this.items.splice(index, 1);
      //     });
      // }
      this.isLoading = false;
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    printjv: async function() {
      if (this.model.jurnalkey) {
        try {        this.reportUrl=null; this.showReport = true;

          this.reportUrl = await jurnal.printjv({ nomor: this.model.no_jurnal, tanggal: moment(this.model.tanggal).format('YYYY-MM-DD'), kodejurnal: this.model.kodejurnal });

        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select one Data taht want to print ");
      }
    },
    posting: async function() {
      if (this.model.jurnalkey) {
        this.isLoading = true;
        try {
          const response = await jurnal.posting(this.model);
          this.refresh();
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else {
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      } else {
        toastr.warn("Please select one Data taht want to print ");
      }
    },
    postingall: async function() {
      this.isLoading = true;
      if (!((this.tblData.tgl1) || (this.tblData.tgl2))) {
          toastr.error('Date range is invalid');
          return;
      }                            

      try {
         await jurnal.postingall(this.tblData);
        this.refresh();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else {
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
      this.refresh();
    },
    postingselected: async function() {
      this.isLoading = true;
      try {
        if (this.selected.length > 0) {
          // const listSelected = [];
          // this.selected.map(item => {
          //   const findmap = listSelected.find(
          //     x => x.no_jurnal === item.no_jurnal
          //   );
          //   if (!findmap) {
          //     listSelected.push(item);
          //   }
          // });
          // await jurnal.postingselected(listSelected);
          await jurnal.postingselected(this.selected);
          this.selected = [];
          // uncheck setelah posting selected
          // $('[name="selectjurnal"]').each(function() {
          //     $(this).prop("checked", false);
          //   });
          this.refresh();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          toastr.warn("Please select row(s) that want to be Posting!");
        }
      } catch (error) {
        this.isLoading = false;
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    exportxls: async function() {
      this.isLoading = true;
      try {
         await jurnal.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    uploadJv: async function() {
      if (this.fileXlsx) {
        //  console.log('FileXlsx : ', this.fileXlsx);
        this.isLoading = true;
        try {
          const response = await jurnal.upload(this.fileXlsx);
          this.isLoading = false;
          console.log(response);
        } catch (error) {
          this.isLoading = false;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else {
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      } else {
        toastr.warn("Please select one File XLSX that want to Upload ");
      }
    },
    close() {
      router.push("home");
    }
  }
};
</script>
